// extracted by mini-css-extract-plugin
module.exports = {"upload-loading":"style_upload-loading__1A0gT","t-human-spread":"style_t-human-spread__3WhcA"};